const symbolaFontFace = () => [...document.fonts].find(ff => ff.family.includes("SymbolaRegular"));

export default {
  up: "🠉",
  down: "🠋",
  left: "🠈",
  right: "🠊",
  onload: callback => symbolaFontFace().loaded.then(callback),
};
